import { TBinDistributionData } from 'types/models/DataAnalysis'
import { FALLBACK_COLOR } from '../../utils/wheatCodeColors'

export const toBinDistributionChartData = (
  arr: TBinDistributionData[],
  mode: 'count' | 'percentage' = 'percentage'
): {
  rows: any[]
  series: { key: string; name: string; color: string }[]
} => {
  if (!Array.isArray(arr)) return { rows: [], series: [] }

  const binKeys = new Set<string>()
  arr.forEach((item) => {
    Object.keys(item.bin_distribution).forEach((k) => binKeys.add(k))
  })

  const series = Array.from(binKeys).map((binKey) => {
    const color =
      arr.find((a) => a.bin_distribution[binKey])?.bin_distribution[binKey]
        .color_hex_code ?? FALLBACK_COLOR
    return {
      key: binKey,
      name: binKey,
      color,
    }
  })

  const rows = arr.map((item) => {
    const row: Record<string, any> = {
      wheatLabel: `Wheat ${item.wheat_code}`,
      total: item.total_samples_in_wheat_code,
      spread_score: item.spread_score,
    }
    series.forEach((s) => {
      const bin = item.bin_distribution[s.key]
      row[s.key] = bin ? (mode === 'count' ? bin.count : bin.percentage) : 0
    })
    return row
  })

  return { rows, series }
}
